import { useEffect } from 'react';

export default function BotHoneypotPage() {
  useEffect(() => {
    // Log bot visit for admin monitoring
    const params = new URLSearchParams(window.location.search);
    const source = params.get('source') || 'direct';
    console.warn(`[HONEYPOT] Bot trap triggered from: ${source}`);
  }, []);

  const fakeRecords = Array.from({ length: 50 }, (_, i) => ({
    id: `rec-${1000 + i}`,
    patient: `Patient-${Math.random().toString(36).substring(7)}`,
    date: new Date(
      2020 + Math.floor(Math.random() * 6),
      Math.floor(Math.random() * 12),
      Math.floor(Math.random() * 28) + 1
    )
      .toISOString()
      .split('T')[0],
  }));

  return (
    <div className="min-h-screen bg-gray-50 p-8 relative">
      {/* Bot-visible content - fake medical database */}
      <div className="max-w-6xl mx-auto">
        <h1 className="text-3xl font-bold text-gray-800 mb-6">
          Medical Records Database - Internal Access
        </h1>
        <p className="text-gray-600 mb-8">
          Confidential patient records - Authorized personnel only
        </p>

        <div className="grid gap-4">
          {fakeRecords.map((record) => (
            <a
              key={record.id}
              href={`/bot-honeypot?record=${record.id}&token=${Math.random().toString(36).substring(2)}`}
              className="block p-4 bg-white rounded-lg border hover:bg-gray-100"
            >
              <div className="flex justify-between">
                <span className="font-mono text-sm">{record.id}</span>
                <span className="text-sm text-gray-500">{record.date}</span>
              </div>
              <div className="text-sm text-gray-700 mt-1">{record.patient}</div>
            </a>
          ))}
        </div>

        {/* Fake pagination to keep bots clicking */}
        <div className="flex gap-2 mt-8 justify-center">
          {Array.from({ length: 20 }, (_, i) => (
            <a
              key={i}
              href={`/bot-honeypot?page=${i + 1}&offset=${i * 50}`}
              className="px-3 py-1 bg-white border rounded hover:bg-gray-100 text-sm"
            >
              {i + 1}
            </a>
          ))}
        </div>

        {/* Fake forms to trap bots */}
        <div className="mt-12 p-6 bg-white rounded-lg border">
          <h2 className="text-xl font-bold mb-4">Export Patient Data</h2>
          <form action="/bot-honeypot" method="POST" className="space-y-4">
            <input
              type="text"
              name="doctor_id"
              placeholder="Doctor ID"
              className="w-full p-2 border rounded"
            />
            <input
              type="text"
              name="access_code"
              placeholder="Access Code"
              className="w-full p-2 border rounded"
            />
            <select name="format" className="w-full p-2 border rounded">
              <option>CSV</option>
              <option>JSON</option>
              <option>XML</option>
            </select>
            <button type="submit" className="px-4 py-2 bg-clinic-blue text-white rounded">
              Export All Records
            </button>
          </form>
        </div>

        {/* More fake links labyrinth */}
        <div className="mt-12 grid grid-cols-3 gap-4">
          {Array.from({ length: 30 }, (_, i) => (
            <a
              key={i}
              href={`/bot-honeypot?section=${i}&filter=all&sort=desc&api=v${i % 3}`}
              className="text-sm text-blue-600 underline"
            >
              API Endpoint {i + 1} - Patient Data Feed
            </a>
          ))}
        </div>
      </div>

      {/* Human-friendly overlay - real users see this immediately */}
      <div className="fixed inset-0 bg-white flex items-center justify-center z-50">
        <div className="text-center p-8 max-w-md">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-shield-check-line text-3xl text-red-600"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Sécurité active</h2>
          <p className="text-gray-600">
            Cette page est un piège de sécurité pour les robots IA indésirables.
            Si vous voyez ce message, vous n&apos;êtes pas un robot.
          </p>
          <a
            href="/"
            className="inline-block mt-6 px-6 py-3 bg-clinic-green text-white rounded-full hover:bg-clinic-green/90 transition-all font-semibold whitespace-nowrap"
          >
            <i className="ri-home-line mr-2"></i>
            Retour à l&apos;accueil
          </a>
        </div>
      </div>
    </div>
  );
}